import qs from "query-string";
import { useQuery } from "react-query";
import { GetKesimpulanResponse, ParamsKesimpulan } from "../../constants/types";
import axios from "../axios";

const handleRequest = async (params: ParamsKesimpulan) => {
    const apiGetKesimpulan = qs.stringifyUrl({
        url: "api/laporan/kesimpulaninvoice",
        query: {
            ukmId: params.ukmId,
            tanggal: params.tanggal,
            grupProduk: params.grupProduk,
            isShift: params.isShift,
            shiftId: params.shiftId
        },
    });
    const { data } = await axios.get<GetKesimpulanResponse>(apiGetKesimpulan);
    return data.data;
};

export default function useKesimpulan(params: ParamsKesimpulan) {
    return useQuery<GetKesimpulanResponse["data"]>(
        ["Kesimpulan", params],
        () => handleRequest(params),
        {
            enabled: !!params.ukmId,
        },
    );
}
